module.exports = __webpack_public_path__ + "img/pick5.55fc206f.png";